export enum CardOrderTypeEnum {
  Binding = 1,
  Deposit = 2,
  Verification = 3,
}
